/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Language as UserServiceContractLanguage } from '../../models/UserService/Contract/language';

export interface ApiLoginListLanguagesGet$Params {
}

export function apiLoginListLanguagesGet(http: HttpClient, rootUrl: string, params?: ApiLoginListLanguagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserServiceContractLanguage>>> {
  const rb = new RequestBuilder(rootUrl, apiLoginListLanguagesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserServiceContractLanguage>>;
    })
  );
}

apiLoginListLanguagesGet.PATH = '/api/Login/ListLanguages';
